import { render, staticRenderFns } from "./HisInfoColumnWidthTable.vue?vue&type=template&id=6b3e1b72&scoped=true&"
import script from "./HisInfoColumnWidthTable.vue?vue&type=script&lang=ts&"
export * from "./HisInfoColumnWidthTable.vue?vue&type=script&lang=ts&"
import style0 from "./HisInfoColumnWidthTable.vue?vue&type=style&index=0&id=6b3e1b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e1b72",
  null
  
)

export default component.exports